import { render, staticRenderFns } from "./BusinessMetrics.vue?vue&type=template&id=58819f09&scoped=true"
import script from "./BusinessMetrics.vue?vue&type=script&lang=js"
export * from "./BusinessMetrics.vue?vue&type=script&lang=js"
import style0 from "./BusinessMetrics.vue?vue&type=style&index=0&id=58819f09&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58819f09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58819f09')) {
      api.createRecord('58819f09', component.options)
    } else {
      api.reload('58819f09', component.options)
    }
    module.hot.accept("./BusinessMetrics.vue?vue&type=template&id=58819f09&scoped=true", function () {
      api.rerender('58819f09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/dashboardSolicitudes/components/BusinessMetrics.vue"
export default component.exports